import { useState } from "react";
import { motion } from "framer-motion";
import productsData from "@/data/products.json";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/context/LanguageContext";

export default function Products() {
  const { t } = useLang();
  const [active, setActive] = useState("All");
  const categories = [
    { key: "All", label: t("filter_all") },
    { key: "Makhana", label: t("filter_makhana") },
    { key: "Garbage Bags", label: t("filter_bags") },
  ];
  const filtered = active === "All" ? productsData : productsData.filter((p) => p.category === active);

  return (
    <div className="pt-36 pb-24" data-testid="products-page">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal>
          <p className="label-eyebrow">{t("products_eyebrow")}</p>
          <h1 className="mt-3 font-serif font-light text-5xl md:text-7xl text-white leading-none">
            {t("products_t1")} <span className="text-gold-gradient italic">{t("products_t2")}</span>
          </h1>
          <p className="mt-5 max-w-xl text-white/60 font-light">{t("products_subtitle")}</p>
        </Reveal>

        <div className="mt-10 flex flex-wrap gap-3" data-testid="product-filters">
          {categories.map((c) => (
            <button
              key={c.key}
              onClick={() => setActive(c.key)}
              data-testid={`filter-${c.key.toLowerCase().replace(/\s/g, "-")}`}
              className={`rounded-full border px-6 py-2.5 text-xs uppercase tracking-[0.18em] transition-colors ${
                active === c.key
                  ? "border-gold bg-gold text-navy-900 font-semibold"
                  : "border-gold/25 text-white/70 hover:border-gold hover:text-gold"
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>

        <motion.div layout className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {filtered.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </motion.div>
      </div>
    </div>
  );
}
